export const SET_LEAD_FORM_V2_STATE = 'SET_LEAD_FORM_V2_STATE';
export const SAVE_FORM_CONFIG = 'SAVE_FORM_CONFIG';
export const SAVE_FORM_DATA = 'SAVE_FORM_DATA';
export const SAVE_LEAD_ID = 'SAVE_LEAD_ID';
export const RESET_LEAD_FORM_V2_STATE = 'RESET_LEAD_FORM_V2_STATE';
export const RESET_LEAD_FORM_V2_FETCH_CONFIG_STATE = 'RESET_LEAD_FORM_V2_FETCH_CONFIG_STATE';

export const setLeadFormV2State = data => {
    return {
        type: SET_LEAD_FORM_V2_STATE,
        data
    };
};

export const saveFormConfig = data => {
    return {
        type: SAVE_FORM_CONFIG,
        data
    };
};

export const saveFormData = data => {
    return {
        type: SAVE_FORM_DATA,
        data
    };
};

export const saveLeadId = leadId => {
    return {
        type: SAVE_LEAD_ID,
        leadId
    };
};

export const resetLeadFormV2State = () => {
    return {
        type: RESET_LEAD_FORM_V2_STATE
    };
};

export const resetLeadFormV2FetchConfigState = () => {
    return {
        type: RESET_LEAD_FORM_V2_FETCH_CONFIG_STATE
    };
};
